/*global Status:readonly*/
/*exported delay debounce*/
'use strict';

// Exclude links from the app routing
$('#footer a').attr('target', '_self');

require('../library/lodash/lodash.min.js');
require('../library/ng-cookies/angular-cookies.js');
require('../library/ui-bootstrap/ui-bootstrap-custom-tpls-2.1.4.js');
require('../library/ui-bootstrap/ui-bootstrap-tpls-2.5.0.js');
require('../library/validator/sd-remote-validator.js');
require('../library/pnotify/pnotify.custom.js');
require('../library/angular-simple-logger/angular-simple-logger.min.js');
require('../library/promise-tracker/2.1.0/promise-tracker.js');
require('../library/promise-tracker/2.1.0/promise-tracker-http-interceptor.js');
require('../library/angular-ui/angular-google-maps.min.js');
require('../library/angular-symfony-translation/angular-symfony-translation.min.js');

/* App Module */
var b2bLoginApp = angular.module('b2bLoginApp', [
    'ngCookies',
    'ngRoute',
    'ngSanitize',
    'ngTable',
    'ajoslin.promise-tracker',
    'ui.bootstrap',
    'uiGmapgoogle-maps',
    'b2bLoginApp.routers',
    'b2bLoginApp.filters',
    'b2bLoginApp.controllers',
    'b2bLoginApp.services',
    'b2bLoginApp.directives',
    'b2bLoginApp.validators',
    'sdCompanyProfileModule',
    'boxuk.translation',
    'ngFileUpload',
    'ui.bootstrap.collapse',
    'sdRemoteValidation',
    'ngMessages',
]);
b2bLoginApp.constant('countriesWithLeadingZeroesPostalCodes', ['it', 'fr']);
b2bLoginApp.constant('cssManifestName', 'manifest.json');

angular.module('b2bLoginApp.controllers', []);
angular.module('b2bLoginApp.services', ['ngResource']);
angular.module('b2bLoginApp.filters', []);
angular.module('b2bLoginApp.validators', []);
angular.module('b2bLoginApp.directives', []);
angular.module('b2bLoginApp.routers', []);
angular.module('sdCompanyProfileModule', []);

angular.module('b2bLoginApp.controllers').controller('BaseController',
    ["$scope", "$route", "$routeParams", "$location", "$window", "$sce", "$uibModal", "$http", "Loading", "Company", "Area", "Contact", "Notification", "NotificationFeedbackInterceptor", "$timeout", "TranslationService", "CompanySites", function ($scope, $route, $routeParams, $location, $window, $sce, $uibModal, $http, Loading, Company, Area, Contact, Notification,
              NotificationFeedbackInterceptor, $timeout, TranslationService, CompanySites) {
        // Publics
        $scope.navigation = {};
        $scope.siteAreas = [];
        $scope.limitType = null;
        $scope.company = null;
        $scope.companyProfile = null;
        $scope.isLinkedSubAccount = null;
        $scope.activePage = null;
        $scope.userCompanies = [];
        $scope.title = {
            default: null,
            override: null
        };

        $http.get('isLinkedSubAccount').then(function (response) {
            $scope.isLinkedSubAccount = response.data;
        });

        $scope.datepickerOptions = {
            minDate: addDays(1),
            maxDate: addDays(21)
        };

        $scope.getUserCompanies = function() {
            $http.get('user-companies').then(function (response) {
                $scope.userCompanies = response.data;
            });
        };

        $scope.$watch('company.status', function (valueNew) {
            if (valueNew === undefined) {
                return;
            }

            $scope.getUserCompanies();
        });

        // Free trial badge
        $scope.showFreeTrialBadge = false;
        $scope.freeTrialBadgeColor = 'header-status-badge--blue';
        $scope.freeTrialBadgeText = '';

        $scope.$watch('company.status', function (status) {
            if (status === undefined) {
                return;
            }

            var isFreeTrial = status === Status.FREE_TRIAL;
            var isBlockedFreeTrial = status === Status.BLOCKED_FREE_TRIAL;

            if (!isFreeTrial && !isBlockedFreeTrial) {
                $scope.showFreeTrialBadge = false;
                return;
            }

            if ($scope.company.abTest !== 'free_trial_experience__b') {
                $scope.showFreeTrialBadge = false;
                return;
            }

            $http.get('free-trial-panel').then(function (response) {
                var data = response.data;
                $scope.showFreeTrialBadge = true;

                if (isBlockedFreeTrial) {
                    $scope.freeTrialBadgeColor = 'header-status-badge--red';
                    $scope.freeTrialBadgeText = TranslationService.trans('free_trial.badge.ended');
                } else if (data.isExtended || data.daysLeft <= 3) {
                    $scope.freeTrialBadgeColor = 'header-status-badge--orange';
                    $scope.freeTrialBadgeText = TranslationService.trans('free_trial.badge.free_trial');
                } else {
                    $scope.freeTrialBadgeColor = 'header-status-badge--blue';
                    $scope.freeTrialBadgeText = TranslationService.trans('free_trial.badge.free_trial');
                }
            }, function () {
                $scope.showFreeTrialBadge = false;
            });
        });

        $scope.isActivePage = function (path) {
            var slug = $location.path();
            if (typeof slug === 'undefined') {
                return false;
            }
            if (path === '/') {
                return slug.length < 2;
            }
            return slug.substr(0, path.length) === path;
        };

        $scope.getCompanySites = function () {
            CompanySites.query({}, function (data) {
                $scope.companySites = data;
            });
        };

        $scope.getCompanySitesIds = function () {
            var ids = [];
            if ($scope.companySites != null) {
                for (var i = 0; i < $scope.companySites.length; i++) {
                    ids.push($scope.companySites[i].id);
                }
            }
            return ids;
        };

        $scope.getAreas = function () {
            $scope.siteAreas = Area.query({siteIds: JSON.stringify($scope.getCompanySitesIds())});
        };

        $scope.invalidateAreas = function () {
            $scope.siteAreas = [];
        };

        $scope.getCompany = function () {
            if ($scope.company === null) {
                $scope.company = Company.get();
            }
            return $scope.company;
        };
        $scope.invalidateCompany = function () {
            $scope.company = null;
        };

        $scope.showFeedback = function () {
            var feedback = window.b2bLoginAppFeedback || [];

            for (var key in feedback) {
                if (!Object.prototype.hasOwnProperty.call(feedback, key)) {
                    continue;
                }
                var item = feedback[key];
                Notification.closeAll();
                switch (item.type) {
                    case 'error':
                        Notification.error(null, item.text);
                        break;
                    case 'success':
                        Notification.success(null, item.text);
                        break;
                    case 'message':
                    default:
                        Notification.message(null, item.text);
                        break;
                }
            }
        };

        // Loading logic
        $scope.loading = Loading;
        $scope.loadingText = null;

        $scope.loginExpired = true;
        $scope.$watch(NotificationFeedbackInterceptor.loginExpired, function (value) {
            $scope.loginExpired = value;
        });

        // Set the page as a class
        $scope.page = function () {
            var regexp = /.*\/(.+)\/(.+)\/(.+)\.html/;
            return $route.current.loadedTemplateUrl.replace(regexp, '$1-$2');
        };

        $scope.goto = function (path, forceRefresh) {
            if (angular.isDefined(forceRefresh) && forceRefresh) {
                $window.location.replace(path);

                return;
            }
            $location.path(path);
        };

        $scope.$on('$routeChangeSuccess', function ($event, $route, $current) {
            $scope.company = $scope.getCompany();

            var page = $location.path().split('/');
            $scope.title.default = (page && page[1] != '') ? TranslationService.trans(page[1] + '.title') : TranslationService.trans('overview.title');

            if (typeof $current !== 'undefined') {
                Notification.closeAll();
            }

            $('#navbar').collapse('hide');

            $('body').scrollTop(0);
        });

        $scope.$watch('$viewContentLoaded', function () {
            $scope.showFeedback();
        });

        $scope.Status = window.Status;

        $scope.Country = window.Country;

        $scope.isBillingVisible = function () {
            if ($scope.company === null || typeof $scope.company.status === 'undefined') {
                return false;
            }

            if ($scope.isLinkedSubAccount) {
                return false;
            }

            return $.inArray($scope.company.status, [
                Status.CLIENT,
                Status.NOT_ACTIVE,
                Status.REMOVED,
                Status.NOT_PAID,
                Status.HOLIDAY,
                Status.ON_BREAK,
                Status.COLLECTING_AGENCY,
                Status.BANKRUPT
            ]) > -1;
        };

        $scope.isOnBreak = function () {
            return $.inArray($scope.company.status, [
                Status.ON_BREAK
            ]) > -1;
        };

        $scope.openContactDialog = function () {
            var contactDialog = $uibModal.open({
                templateUrl: '/account/contact.html',
                scope: $scope,
                backdrop: 'static',
                keyboard: false,
                size: 'lg',
                controller: function () {
                    $scope.data = {
                        subject: '',
                        message: ''
                    };

                    $scope.save = function () {
                        var contact = new Contact({
                            subject: $scope.data.subject,
                            message: $scope.data.message
                        });
                        contact.$save().then(function () {
                            contactDialog.close();
                        });
                    };
                }
            });
        };

        $scope.getLoginStatus = function (statusId) {
            var map = {
                2: 'active',    // Client
                3: 'cancelled', // Not active
                5: 'cancelled', // Removed
                6: 'paused',    // Not paid
                7: 'paused',    // Holiday
                8: 'paused',    // Break
                9: 'paused',    // Waiting on forms client
                10: 'cancelled', // Collecting agency
                11: 'cancelled', // Bankrupt
                12: 'paused',    // Wait for confirmation free trial
                13: 'paused',    // Queue list free trial
                14: 'expired',   // Block free trial
                16: 'active',    // Just registered free trial
                17: 'active',    // Free trial
                18: 'expired',   // Waiting on forms free trial
                19: 'prospect'   // Prospect
            };
            return map[statusId];
        };

        $scope.$watch('data.disableReactivationDate', function (disableReactivationDate) {
            if (angular.isDefined($scope.data)) {
                if (disableReactivationDate) {
                    $scope.initial_vacation_date = $scope.data.vacation_end;
                    $scope.data.vacation_end = null;
                } else {
                    $scope.data.vacation_end = $scope.initial_vacation_date;
                }
            }
        });

        $scope.$watch('datepicker', function (newDate) {
            $scope.formatDate(newDate);
        });

        $scope.formatDate = function (date) {
            if (date instanceof Date && !isNaN(date) && angular.isDefined($scope.data)) {
                // This date should not depend on browser locale, so we always set it to midnight in ISO format
                let utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
                $scope.data.vacation_end = utcDate.toISOString();
            }
        };

        $scope.logout = function () {
            window.location = '/account/logout';
        };

        window.onbeforeunload = function () {
            Loading.createPromise();
        };
    }]);

// eslint-disable-next-line no-unused-vars
var delay = (function () {
    var timer = 0;
    return function (callback, ms) {
        clearTimeout(timer);
        timer = setTimeout(callback, ms);
    };
})();

// IE8 :-(
if (!('indexOf' in Array.prototype)) {
    Array.prototype.indexOf = function (find, i /*opt*/) {
        if (i === undefined) i = 0;
        if (i < 0) i += this.length;
        if (i < 0) i = 0;
        for (var n = this.length; i < n; i++)
            if (i in this && this[i] === find)
                return i;
        return -1;
    };
}

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
// eslint-disable-next-line no-unused-vars
function debounce(func, wait, immediate) {
    var timeout;
    return function () {
        var context = this, args = arguments;
        var later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}

function addDays(days) {
    var result = new Date();
    result.setDate(result.getDate() + days);
    return result;
}

require('./app_configuration.js');
require('./indeterminate.js');
require('./polyfill.js');
require('./recursion-helper.js');
require('./sd-mobile-menu.js');
require('./app_routers.js');

require('./areas/areas-controller.js');
require('./areas/areas-region-tree-directive-widget.js');
require('./areas/areas-region-tree-directive.js');
require('./areas/areas-service.js');
require('./areas/dropdown.js');
require('./areas/london-validator.js');
require('./areas/rates-service.js');
require('./areas/site-rates-directive.js');

require('./company_profile_public/company-profile-a-module.js');
require('./company_profile_public/company-profile-controller.js');
require('./company_profile_public/company-profile-nav-directive.js');
require('./company_profile_public/company-profile-notice-directive.js');
require('./company_profile_public/company-profile-share-directive.js');
require('./company_profile_public/company_profile_public-controller.js');
require('./company_profile_public/company_profile_public-delete_photo-directive.js');
require('./company_profile_public/company_profile_public-edit_photo-directive.js');
require('./company_profile_public/company_profile_public-editable-directive.js');
require('./company_profile_public/company_profile_public-error-notice-directive.js');
require('./company_profile_public/company_profile_public-external-reviews-controller.js');
require('./company_profile_public/company_profile_public-google-reviews-controller.js');
require('./company_profile_public/google-stars-directive.js');
require('./company_profile_public/company_profile_public-widget-datails-controller.js');
require('./company_profile_public/company_profile_public-service.js');
require('./company_profile_public/company_profile_public-profile-strength-service.js');
require('./company_profile_public/company_profile_public-upload_photo-directive.js');
require('./company_profile_public/croppy-directive.js');

require('./components/company/company-service.js');
require('./components/filters/no_fraction_currency-filter.js');
require('./components/filters/postal_code_padding-filter.js');
require('./components/filters/capitalize-filter.js');
require('./components/infobar/infobar-controller.js');
require('./components/infobar/infobar-directive.js');
require('./components/loading/loading_interceptor-service.js');
require('./components/loading/loading-service.js');
require('./components/notification/notification_feedback_interceptor-service.js');
require('./components/notification/notification-service.js');
require('./components/status_action/status_action-directive.js');

require('./contact/contact-service.js');
require('./error/not_found-controller.js');
require('./company_settings/CompanySettingsService.js');
require('./indeterminate.js');
require('./js/directives/bind-html-compile-directive.js');
require('./js/directives/convert-to-number.js');

require('./js/location/location-map-directive.js');

require('./polyfill.js');
require('./pricing/sites-service.js');
require('./recursion-helper.js');
require('./sd-mobile-menu.js');
